export interface IShopifyAddress {
  address1: string
  address2: string | null
  city: string
  company: null
  country: string
  country_code: string
  country_name: string
  customer_id: number
  default: false
  first_name: string
  id: number
  last_name: string
  name: string
  phone: string
  province: string
  province_code: string
  zip: string
}

export interface IShopifyMailingAddressInput {
  address1: string
  address2: string | null
  city: string
  company: null
  country: string
  firstName: string
  lastName: string
  phone: string
  province: string
  zip: string
}
